export const COACH = "coach"
export const ADMIN = "admin"
export const LEADER = "leader"
export const MANAGER = "manager"
export const MEMBER = "member"
export const RECOGNITION = "recognition"
export const ALIGNMENT = "alignment"
export const COMMUNITY = "community"

export const ALL_ROLES = [
  COACH,
  ADMIN,
  LEADER,
  MANAGER,
  MEMBER,
  RECOGNITION,
  ALIGNMENT,
  COMMUNITY
]
export const INVITABLE_ROLES = [
  ADMIN,
  LEADER,
  MANAGER,
  MEMBER,
  RECOGNITION,
  ALIGNMENT,
  COMMUNITY
]
export const COMMUNITY_ROLES = [
  COACH,
  ADMIN,
  LEADER,
  MANAGER,
  MEMBER,
  RECOGNITION,
  COMMUNITY
]
export const PLAN_ACCESS_ROLES = [
  COACH,
  ADMIN,
  LEADER,
  MANAGER,
  MEMBER,
  RECOGNITION
]
export const TEAM_MEMBER_ROLES = [COACH, ADMIN, LEADER, MANAGER, MEMBER]
export const NON_COACH_ROLES = [ADMIN, LEADER, MANAGER, MEMBER, RECOGNITION]
export const MANAGEMENT_ROLES = [COACH, ADMIN, LEADER, MANAGER]
export const LEADERSHIP_ROLES = [COACH, ADMIN, LEADER]
export const ADMIN_ROLES = [COACH, ADMIN]
export const MEMBER_ROLES = [MEMBER, MANAGER]
export const NON_COACH_LEADERSHIP_ROLES = [ADMIN, LEADER]
